import React from 'react';
import ButtonModalSK from './ButtonModalSK';

export const cellRenderButtonModalSK = (data) => {
  if (data.value && data.value !== '') {
    return (
      <ButtonModalSK data={data} />
    );
  }
  return '';
};
